<template>
  <div class="custom-checkbox">
    <input v-if="type === 'checkbox'" type="checkbox" :name="name" :value="value" :id="uniqueId" @change.prevent="onChange" />
    <input v-else type="radio" :name="name" :value="value" :id="uniqueId" @input.prevent="onInput" />
    <label :for="uniqueId">{{ label }}</label>
  </div>
</template>

<script>
  export default {
    name: 'Checkbox',
    props: {
      value: {},
      dataValue: {},
      label: {
        type: String
      },
      name: {
        type: String
      },
      type: {
        type: String,
        default: 'checkbox'
      }
    },
    data() {
      const randomNumber = Math.floor(Math.random() * 10000) + 1;
      return {
        uniqueId: `${this.type}-${randomNumber}`
      }
    },
    methods: {
      onChange: function (ev) {
        console.log('change new value: ', !this.value)
        this.$emit('input', !this.value)
      },
      onInput: function (ev) {
        console.log('input new value: ', this.dataValue)
        this.$emit('input', this.dataValue)
      }
    }
  }
</script>

<style lang="scss" scoped>
  input[type="checkbox"],
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  label {
    position: relative;
    margin-right: 1em;
    padding-left: 2em;
    padding-right: 1em;
    line-height: 2;
    cursor: pointer;
    color: #ff595a;
    &:before {
      box-sizing: border-box;
      content: " ";
      position: absolute;
      top: 0em;
      left: 0;
      display: block;
      width: 1.4em;
      height: 1.4em;
      border: 2px solid #ff595a;
      border-radius: .25em;
      z-index: 0;
    }
  }
  input[type="radio"] + label::before {
    border-radius: 1em;
  }
  /* Checked */
  input[type="checkbox"]:checked + label,
  input[type="radio"]:checked + label {
    background-color: #ff595a;
    color: white;
    border-radius: 20px;
    padding: .3em 2em;
    //color: white;
    &:before {
      top: 0em;
      width: 100%;
      height: 1.8em;
      //background: #ff595a;
    }
  }
  
  /* Transition */
  label,
  label::before {
    -webkit-transition: .25s all ease;
    -o-transition: .25s all ease;
    transition: .25s all ease;
  }
</style>
